var map = {
	"./404/locale": 477,
	"./404/locale.json": 477,
	"./404/media": 478,
	"./404/media.json": 478,
	"./404/setting": 479,
	"./404/setting.json": 479,
	"./about/locale": 480,
	"./about/locale.json": 480,
	"./about/media": 481,
	"./about/media.json": 481,
	"./about/setting": 482,
	"./about/setting.json": 482,
	"./business/link": 483,
	"./business/link.json": 483,
	"./business/locale": 484,
	"./business/locale.json": 484,
	"./business/media": 485,
	"./business/media.json": 485,
	"./business/setting": 486,
	"./business/setting.json": 486,
	"./business_services_registration/locale": 487,
	"./business_services_registration/locale.json": 487,
	"./business_services_registration/setting": 488,
	"./business_services_registration/setting.json": 488,
	"./contact/locale": 489,
	"./contact/locale.json": 489,
	"./contact/setting": 490,
	"./contact/setting.json": 490,
	"./faq/locale": 491,
	"./faq/locale.json": 491,
	"./faq/setting": 492,
	"./faq/setting.json": 492,
	"./general/link": 452,
	"./general/link.json": 452,
	"./general/locale": 445,
	"./general/locale.json": 445,
	"./general/media": 493,
	"./general/media.json": 493,
	"./general/setting": 466,
	"./general/setting.json": 466,
	"./index/locale": 471,
	"./index/locale.json": 471,
	"./index/media": 494,
	"./index/media.json": 494,
	"./index/setting": 495,
	"./index/setting.json": 495,
	"./legal/locale": 496,
	"./legal/locale.json": 496,
	"./legal/setting": 497,
	"./legal/setting.json": 497,
	"./mobile/pricing/locale": 498,
	"./mobile/pricing/locale.json": 498,
	"./mobile/pricing/media": 499,
	"./mobile/pricing/media.json": 499,
	"./mobile/pricing/setting": 500,
	"./mobile/pricing/setting.json": 500,
	"./password/locale": 501,
	"./password/locale.json": 501,
	"./password/setting": 502,
	"./password/setting.json": 502,
	"./pricing/locale": 503,
	"./pricing/locale.json": 503,
	"./pricing/media": 504,
	"./pricing/media.json": 504,
	"./pricing/setting": 505,
	"./pricing/setting.json": 505,
	"./quoting/locale": 506,
	"./quoting/locale.json": 506,
	"./quoting/media": 507,
	"./quoting/media.json": 507,
	"./quoting/setting": 508,
	"./quoting/setting.json": 508,
	"./service/link": 509,
	"./service/link.json": 509,
	"./service/locale": 510,
	"./service/locale.json": 510,
	"./service/media": 511,
	"./service/media.json": 511,
	"./service/setting": 512,
	"./service/setting.json": 512,
	"./sitemap/setting": 513,
	"./sitemap/setting.json": 513,
	"./template_for_angular/locale": 514,
	"./template_for_angular/locale.json": 514,
	"./template_for_angular/setting": 515,
	"./template_for_angular/setting.json": 515,
	"./template_for_angular_no_header/locale": 516,
	"./template_for_angular_no_header/locale.json": 516,
	"./template_for_angular_no_header/setting": 517,
	"./template_for_angular_no_header/setting.json": 517
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 881;


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/default/setting ^\.\/.*$
// module id = 881
// module chunks = 0 1 2 3 4 5